import type { UploadFile } from 'antd/es/upload/interface';

const normUploadFileList = (e: { fileList?: UploadFile[] } | UploadFile[]) =>
  Array.isArray(e) ? e : e?.fileList;

function getUploadFileList(value: unknown): UploadFile[] {
  if (!value) return [];
  if (Array.isArray(value)) return value as UploadFile[];
  return (value as { fileList?: UploadFile[] }).fileList ?? [];
}

function getUploadOriginFile(
  value: unknown,
): NonNullable<UploadFile['originFileObj']> | undefined {
  const fileList = getUploadFileList(value);
  const fromList = fileList[0]?.originFileObj;
  if (fromList) return fromList;

  const legacy = value as { file?: UploadFile } | undefined;
  return legacy?.file?.originFileObj;
}

function getUploadOriginFiles(
  files: UploadFile[],
): NonNullable<UploadFile['originFileObj']>[] {
  return files
    .map((item) => item.originFileObj)
    .filter((file): file is NonNullable<UploadFile['originFileObj']> =>
      Boolean(file),
    );
}

export {
  getUploadFileList,
  getUploadOriginFile,
  getUploadOriginFiles,
  normUploadFileList,
};
